import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_3 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_cidade = _resolveComponent("selecionar-cidade")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.computedNotaFiscal.destinatario.localEntregaDiferente,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedNotaFiscal.destinatario.localEntregaDiferente) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Local Entrega Diferente")
              ]),
              _: 1
            }, 8, ["checked"])
          ])
        ]),
        (_ctx.computedNotaFiscal.destinatario.localEntregaDiferente)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Endereço/Avenida/Rua",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedNotaFiscal.destinatario.enderecoDiferente.endereco) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.computedNotaFiscal.destinatario.enderecoDiferente.endereco]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_form_item, {
                  label: "Número",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "10",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedNotaFiscal.destinatario.enderecoDiferente.numero) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.computedNotaFiscal.destinatario.enderecoDiferente.numero]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_form_item, {
                  label: "Complemento",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedNotaFiscal.destinatario.enderecoDiferente.complemento) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.computedNotaFiscal.destinatario.enderecoDiferente.complemento]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form_item, {
                  label: "Bairro",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "60",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedNotaFiscal.destinatario.enderecoDiferente.bairro) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.computedNotaFiscal.destinatario.enderecoDiferente.bairro]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_form_item, {
                  label: "Cidade/Estado",
                  class: "ss-margin-campos",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_cidade, {
                      codigoSelecionado: _ctx.computedNotaFiscal.destinatario.enderecoDiferente.codigoCidade,
                      "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedNotaFiscal.destinatario.enderecoDiferente.codigoCidade) = $event)),
                      apresentarEstado: true,
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.obterDadosCidade()))
                    }, null, 8, ["codigoSelecionado"])
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}